import { BaseDataModel } from "@domain/CRM/BaseDataModel";

export class Shift extends BaseDataModel {
	name!: string;
	startDate?: Date;
	endDate?: Date;
	robotId?: string;
	operator?: string;
	operatorId?: string;
	robotName?: string;
	jobIds!: string[];
	url!: string;
	scheduledDate?: Date;
	rigId?: string;
	rigName?: string;
}
